<div id="wrapper">
  <div id="google_map">
    <agm-map *ngIf="centerVehicle" id="agm-map"
             [maxZoom]="selectedTrip?(this.selectedTrip&&this.selectedTrip['isOnGoingTrip']?20:14):16"
             [zoom]="selectedTrip?(this.selectedTrip['isOnGoingTrip']?19:14):(selectedCar?12:20)"
             [latitude]="centerVehicle.lat"
             [longitude]="centerVehicle.lng" [fitBounds]="!selectedCar"
             #agmMap [agmDrawingManager]="drawing">


      <!--      <agm-polygon [paths]="agmPolygonPaths"></agm-polygon>-->
      <agm-circle *ngIf="selectedCircleRegion" [longitude]="selectedCircleRegion.center.lng"
                  [latitude]="selectedCircleRegion.center.lat" [radius]="selectedCircleRegion.radius"></agm-circle>

      <agm-drawing-manager [drawingControl]="false" #drawing="agmDrawingManager" id="agmDrawingManager"
                           [drawingMode]="drawingMode"
                           [polygonOptions]="{draggable:false,editable:false}"
                           (circleComplete)="onDrawingComplete($event);$event.setMap(null)"
                           #agmDrawingManager>
      </agm-drawing-manager>

      <!--      Trip map view starts here-->
      <div *ngIf="selectedTrip">
        <agm-marker
          [latitude]="+selectedTrip.startLat"
          [longitude]="+selectedTrip.startLong"
          [iconUrl]="{ url:'assets/icons/map_start_pin.svg' , scaledSize: {height: 30, width: 30}}"
        >
          <agm-info-window [disableAutoPan]="false">
            <div class="text-center">
              <p>Trip Start</p>
              <p>{{selectedTrip.startLocationName ? selectedTrip.startLocationName : ''}}</p>
            </div>
          </agm-info-window>
        </agm-marker>
        <agm-marker
          [latitude]="selectedTripLiveLocationDetails?selectedTripLiveLocationDetails.lat: +selectedTrip.endLat"
          [longitude]="selectedTripLiveLocationDetails?selectedTripLiveLocationDetails.lng: +selectedTrip.endLong"
          [iconUrl]="{ url:selectedTrip.isOnGoingTrip?'assets/icons/car.svg':'assets/icons/map_dest_pin.svg' , scaledSize: selectedTrip.isOnGoingTrip?{height: 45, width: 45}:{height: 30, width: 30}}"
        >
          <agm-info-window [disableAutoPan]="false">
            <div class="text-center" *ngIf="!selectedTrip.isOnGoingTrip">
              <p>Trip End</p>
              <p>{{selectedTrip.destinationName ? selectedTrip.destinationName : ''}}</p>
            </div>
            <div class="text-center" *ngIf="selectedTrip.isOnGoingTrip">
              <div class="row d-flex justify-content-center">
                <div class="green-dot p-1"></div>
                <p>Live Location</p>
              </div>
              <p>{{selectedTripLiveLocationDetails && selectedTripLiveLocationDetails.locationDetails ? selectedTripLiveLocationDetails.locationDetails.toString() : ''}}</p>
              <p>{{ selectedTripLiveLocationDetails && selectedTripLiveLocationDetails.createdOn ? (selectedTripLiveLocationDetails.createdOn | date :'medium') : ''}}</p>
            </div>
          </agm-info-window>
        </agm-marker>

        <agm-marker

          *ngFor="let m of selectedTripVehicleAlerts;"
          [latitude]="m.latitudeOnAlert"
          [longitude]="m.longitudeOnAlert"
          [label]="'VA'">
          <!--    [iconUrl]="{ url:'assets/icons/map_danger_pin.svg' , scaledSize: {height: 30, width: 30}}"-->
          <agm-info-window [disableAutoPan]="false">

            <div>
              <p class="text-center">Vehicle Alert</p>
              <p>Trouble Code: <b>{{m.troubleCode}}</b></p>
              <p>Error Description: <b>{{m.errorDesc}}</b></p>
              <p>Alert Fixed: <span class="text-success" *ngIf="m.alertFixed"><i class="fa fa-check"></i></span>
                <span class="text-danger" *ngIf="!m.alertFixed"><i class="fa fa-times p-2"></i></span></p>
            </div>

          </agm-info-window>
        </agm-marker>


        <agm-marker

          *ngFor="let m of selectedTripDrivingAlerts;"
          [latitude]="m.lat"
          [longitude]="m.long"
          [label]="m.label">
          <!--    [iconUrl]="{ url:'assets/icons/map_danger_pin.svg' , scaledSize: {height: 30, width: 30}}"-->
          <agm-info-window [disableAutoPan]="false" #infoWindow>

            <div>
              <p>Alert Type: <b>{{m.alert_Type}}</b></p>
              <p>Alert Value: <b>{{m.alert_value}}</b></p>
              <p>G Force: <b>{{m.g_force}}</b></p>
              <p>Time Interval: <b>{{m.time_interval}}</b></p>
            </div>

          </agm-info-window>
        </agm-marker>
        <agm-polyline [visible]="true" [strokeWeight]="3" [strokeColor]="'#000000'">
          <agm-polyline-point
            *ngFor="let coordinate of flightPlanCoordinates; let i=index"
            [latitude]="coordinate.lat"
            [longitude]="coordinate.lng">

          </agm-polyline-point>
        </agm-polyline>
      </div>
      <!--      Trip map view ends here-->

      <!--      Available cars list on map starts here-->
      <div *ngFor="let car of availableCars">
        <agm-marker *ngIf="car.latitude && car.longitude"
                    [latitude]="car.latitude"
                    [longitude]="car.longitude"
                    [agmFitBounds]="!selectedCar"
                    (markerClick)="onCarCheckBoxClick(car,true)"
                    [iconUrl]="{
      url: ( car.bearing!=null) ? 'assets/icons/car_rotates/car' +(car.bearing | roundten) + '.svg' : 'assets/icons/car.svg',
      scaledSize: {height: 30, width: 30}
    }"
        >
          <agm-info-window [disableAutoPan]="false" #agmInfoWindow [isOpen]="car.isInfoWindowOpen"
                           (infoWindowClose)="car.isInfoWindowOpen=false">
            <!--            <div class="text-center">-->
            <div class="card p-0 m-0" style="max-width: 400px!important;">
              <div class="card-header p-0 d-flex justify-content-between align-items-center">
                <span class="pl-2">
                {{car.user.userFullName}} | {{car.regNumber |uppercase}}
                </span>
                <div>
                  <button class="btn pt-0 pb-0" type="button" [matMenuTriggerFor]="menu"
                          aria-label="Example icon-button with a menu">
                    <mat-icon>menu</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item
                            (click)="this.onCarCheckBoxClick(car,true);this.matTabGroup.selectedIndex=2;onTabChange(2)">
                      <span>Show Trips</span>
                    </button>
                    <button mat-menu-item
                            (click)="this.onCarCheckBoxClick(car,true);this.matTabGroup.selectedIndex=1;onTabChange(1)">
                      <span>Show Alerts</span>
                    </button>
                    <button mat-menu-item
                            (click)="agmInfoWindow.close(); onCreateGeoFencingClick(car)">
                      <span>Add/Update Geo Fencing</span>
                    </button>
                    <button mat-menu-item *ngIf="car.geoFencingCoordinates"
                            (click)="agmInfoWindow.close(); onViewGeFencingRegionClick(car)">
                      <span>View Geo Fencing Region</span>
                    </button>
                    <button mat-menu-item *ngIf="car.geoFencingCoordinates"
                            (click)="agmInfoWindow.close(); onRemoveGeoFencingClick(car)">
                      <span>Remove Fencing Region</span>
                    </button>
                  </mat-menu>
                </div>
              </div>
              <div class="card-body">
                <div class="row d-flex justify-content-between">
                  <p class="col-4 pr-0">Address:</p>
                  <p
                    class="col-8 pr-0" style="max-width: 250px !important;"
                    *ngIf="car.locationDetails">{{car.locationDetails}}</p>
                  <p
                    class="col-8 pr-0" style="max-width: 250px !important;"
                    *ngIf="!car.locationDetails"><a href="javascript:void(0)"
                                                    (click)="getLiveLocationDetails(car)">Click
                    here</a> to get address</p>
                </div>
                <div class="row d-flex justify-content-between">
                  <p class="col-4 pr-0">Last Updated:</p>
                  <p class="col-8 pr-0">{{car.lastUpdatedOn | date :'medium'}}</p>
                </div>
                <div class="row d-flex justify-content-between" *ngIf="car.speed">
                  <p class="col-4 pr-0">Speed:</p>
                  <p class="col-8 pr-0">{{car.speed}}</p>
                </div>
                <div class="row d-flex justify-content-between">
                  <p class="col-4 pr-0">Stop Duration:</p>
                  <p class="col-8 pr-0">
                    <b><span
                      *ngIf="getStopDuration(car.lastUpdatedOn)['days']">{{getStopDuration(car.lastUpdatedOn)['days']}}
                      days </span>
                      <span
                        *ngIf="getStopDuration(car.lastUpdatedOn)['hours']">{{getStopDuration(car.lastUpdatedOn)['hours']}}
                        h </span><span
                        *ngIf="getStopDuration(car.lastUpdatedOn)['minutes']">{{getStopDuration(car.lastUpdatedOn)['minutes']}}
                        mins</span>
                      <span
                        *ngIf="!getStopDuration(car.lastUpdatedOn)['hours'] && !getStopDuration(car.lastUpdatedOn)['minutes']">-</span>
                    </b>
                  </p>
                </div>
                <!--                </div>-->
              </div>
            </div>
          </agm-info-window>
        </agm-marker>
      </div>
      <!--      Available cars list on map ends here-->
    </agm-map>
  </div>
  <div id="over_map_2" class="">

    <div class="text-right main-expand-btn" style="background-color: transparent!important;">
      <button class="p-0 btn bg-white main-expand-btn"
              (click)="isMainMenuCollapsed = !isMainMenuCollapsed"
              [attr.aria-expanded]="!isMainMenuCollapsed" aria-controls="collapseExample">
        <i class="fa fa-angle-left text-dark fa-2x" matTooltip="Expand" *ngIf="!isMainMenuCollapsed"></i>
        <i class="fa fa-angle-right text-dark fa-2x" matTooltip="Minimize" *ngIf="isMainMenuCollapsed"></i>
      </button>
    </div>
    <mat-tab-group [ngbCollapse]="isMainMenuCollapsed" [color]="'primary'" [style.backgroundColor]="'#f7f7f7'"
                   class="bg-light" #matTabGroup
                   (selectedTabChange)="onTabChange($event.index)" (click)="isMainMenuCollapsed=false">
      <mat-tab label="Cars">
        <div class="p-2 bg-white">
          <div class="row">
            <mat-form-field class="col-10">
              <mat-label>Enter Reg No.</mat-label>
              <input matInput type="text" [(ngModel)]="driverVehiclesSearch.search"
                     (keyup)="getAllDriverVehicles(true)"
                     (focusin)="carSearchInputFocus=true"
                     (focusout)="carSearchInputFocus=false">
              <mat-icon matSuffix *ngIf="!carSearchInputFocus">search</mat-icon>
              <button *ngIf="driverVehiclesSearch.search" matSuffix mat-icon-button aria-label="Clear"
                      (click)="driverVehiclesSearch.search=''">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <div class="col-2 d-flex align-items-center pl-0">
              <div [routerLink]="['../','customers']"
                   class=" pointer bg-danger d-flex justify-content-center align-items-center"
                   style="height: 25px;width: 25px">
                <i class="fa fa-plus text-white"></i>
              </div>
            </div>
          </div>
          <div class=" cars-list-view">
            <div class="row col-12 pr-0 pb-2 " *ngFor="let car of availableCars">
              <div class=" col-12 d-flex justify-content-between pr-0">
                <div class="row d-flex align-items-end">
                  <mat-checkbox class="text-left" (change)="onCarCheckBoxClick(car)"
                                [checked]="car.selected"></mat-checkbox>
                  <div class="pl-2 pointer" (click)="onCarCheckBoxClick(car)">
                    <div><b>{{car.regNumber | uppercase}}</b></div>
                    <div>{{car.user.userFullName}}</div>
                  </div>
                </div>
                <div class=" d-flex justify-content-end align-items-center">
                  <div class="row d-flex align-items-center">
                    <div class="green-dot" *ngIf="isAnyUpdateOfCarInFiveMin(car)"></div>
                    <div class="red-dot" matTooltip="No update from Vehicle in last 5min"
                         *ngIf="!isAnyUpdateOfCarInFiveMin(car)"></div>
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item
                              (click)="this.onCarCheckBoxClick(car,true);this.matTabGroup.selectedIndex=2;onTabChange(2)">
                        <span>Show Trips</span>
                      </button>
                      <button mat-menu-item
                              (click)="this.onCarCheckBoxClick(car,true);this.matTabGroup.selectedIndex=1;onTabChange(1)">
                        <span>Show Alerts</span>
                      </button>
                      <button mat-menu-item
                              (click)="onCreateGeoFencingClick(car)">
                        <span>Add/Update Geo Fencing</span>
                      </button>
                      <button mat-menu-item *ngIf="car.geoFencingCoordinates"
                              (click)="onViewGeFencingRegionClick(car)">
                        <span>View Geo Fencing Region</span>
                      </button>
                      <button mat-menu-item *ngIf="car.geoFencingCoordinates"
                              (click)="onRemoveGeoFencingClick(car)">
                        <span>Remove Fencing Region</span>
                      </button>
                    </mat-menu>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Alerts">
        <div class="p-2 bg-white" [ngbCollapse]="isMainMenuCollapsed">
          <div class="row col-12 pr-0">
            <div class="col-3 d-flex align-items-center p-0 pr-1">
              <span>
              Select Date Range
              </span>
            </div>
            <div class="col-9 p-0">
              <mat-form-field>
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [formGroup]="drivingAlertsDateRange" [rangePicker]="picker">
                  <input matStartDate formControlName="start" placeholder="Start date" (focus)="picker.open()" readonly>
                  <input matEndDate formControlName="end" placeholder="End date" (focus)="picker.open()" readonly
                         (ngModelChange)="onDrivingAlertsDateRangeChange()">
                </mat-date-range-input>
                <button *ngIf="drivingAlertsDateRange&&drivingAlertsDateRange.value.start" matSuffix mat-icon-button
                    aria-label="Clear" matTooltip="Clear date" (click)="onClearDateRangeClick()">
              <mat-icon>close</mat-icon>
            </button>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>

                <mat-error *ngIf="drivingAlertsDateRange.controls.start.hasError('matStartDateInvalid')">Invalid start
                  date
                </mat-error>
                <mat-error *ngIf="drivingAlertsDateRange.controls.end.hasError('matEndDateInvalid')">Invalid end
                  date
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <hr class="p-0 pb-2 m-0">
          <div class="cars-list-view">
            <div class="row col-12 pb-2 pr-0" *ngFor="let da of selectedVehicleDrivingAlerts">
              <div class="col-8 pr-0 pl-0">
                <b>{{da.alert.alert_Type}}</b>
                <p class="mb-0">{{da.createdOn | date :'medium'}}</p>
              </div>
              <div class="col-4 pr-0">{{da.alert.alert_value}}</div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Trips">
        <div [ngbCollapse]="isMainMenuCollapsed" class="p-2 bg-white">
          <div class="row col-12 pr-0">
            <div class="col-3 d-flex align-items-center p-0 pr-1">
              <span>
              Select Date Range
              </span>
            </div>
            <div class="col-9 p-0">
              <mat-form-field>
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [formGroup]="tripsDateRange" [rangePicker]="picker2">
                  <input matStartDate formControlName="start" placeholder="Start date" (focus)="picker2.open()"
                         readonly>
                  <input matEndDate formControlName="end" placeholder="End date" (focus)="picker2.open()" readonly
                         (ngModelChange)="onTripDateRangeChange()">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-date-range-picker #picker2></mat-date-range-picker>

                <mat-error *ngIf="tripsDateRange.controls.start.hasError('matStartDateInvalid')">Invalid start
                  date
                </mat-error>
                <mat-error *ngIf="tripsDateRange.controls.end.hasError('matEndDateInvalid')">Invalid end
                  date
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="cars-list-view">
            <div class="card p-2 mb-0 pointer" *ngFor="let trip of selectedCarTrips" (click)="onTripClick(trip)">
              <div class="card-bod p-0y">
                <p class="mb-0"><b>{{trip.startLocationName}}<i
                  class="fa fa-caret-right pl-2 pr-2"></i>{{trip.destinationName}}
                </b>
                </p>
                <p class="mb-0  "><i class="fa fa-dot-circle"></i> {{trip.startDate | date :'medium'}} <i
                  class="fa fa-dot-circle"></i> Distance: {{trip.distanceCovered}}Km <i class="fa fa-dot-circle"></i>
                  Trip
                  Duration:
                  <span *ngIf=" getTripDuration(trip)['hours']"> {{getTripDuration(trip)['hours']}}
                    h </span><span *ngIf="getTripDuration(trip)['minutes']">{{getTripDuration(trip)['minutes']}}
                    mins </span>
                  <span *ngIf="!getTripDuration(trip)['hours'] && !getTripDuration(trip)['minutes']">-</span>
                  <i class="fa fa-dot-circle"></i> Driving Alerts: {{trip.alertsCount}}
                  <i class="fa fa-dot-circle"></i> Trip Mileage: {{trip.mileage ? trip.mileage : '-'}}
                </p>
              </div>
            </div>
            <span class="text-center" *ngIf="selectedCar && selectedCar.user"><a href="javascript:void(0)"
                                                                                 [routerLink]="['/customers',selectedCar.user.userId,'trips']"
                                                                                 [queryParams]="{customerName:selectedCar.user.userFullName}">View All Trips</a> </span>
          </div>

        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <!--  Selected car alerts box starts here-->
  <div id="over_map_3" *ngIf="selectedCar">
    <div class="bg-transparent d-flex justify-content-center ">
      <button class="p-0 btn vehicle-alerts-toggle-btn"
              (click)="onVehicleAlertsCardToggleBtn()">
        <i class="fa fa-angle-down text-dark fa-1x" matTooltip="Expand" *ngIf="!isVehicleAlertsCardCollapsed"></i>
        <i class="fa fa-angle-up text-dark fa-1x" matTooltip="Minimize" *ngIf="isVehicleAlertsCardCollapsed"></i>
      </button>
    </div>
    <div class="table-responsive col-12 p-0" id="vehicle_alerts_table">
      <table class="table table-bordered bg-white">
        <thead style="background: #F7F7F7 !important;">
        <tr>
          <th scope="col" style="min-width:216px;width: 216px">
            <div class="row">
              <span class="pl-3">{{selectedCar.regNumber |uppercase}}</span>
              <div class=" d-flex align-items-center">
                <div class="pl-1 green-dot" *ngIf="isAnyUpdateOfCarInFiveMin(selectedCar)"></div>
                <div class="pl-1 red-dot" matTooltip="No update from Vehicle in last 5min"
                     *ngIf="!isAnyUpdateOfCarInFiveMin(selectedCar)"></div>
              </div>
            </div>
          </th>
          <th scope="col" style="min-width:216px;width: 216px" class="text-nowrap">Trip Safety</th>
          <th scope="col" style="min-width:216px;width: 216px" class="text-nowrap">Trouble Codes</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td style="min-width:216px;width: 216px" class="text-left">
            <div class="pl-3">
              <!--              Showing only 20 characters in address-->
              <span class="row">Address: <span
                class="text-muted">{{ selectedVehicleLiveLocation ? (selectedVehicleLiveLocation.length > 20 ?
                (selectedVehicleLiveLocation | slice:0:20) + '...' : selectedVehicleLiveLocation) : '' }}
            </span>
            </span>
              <span class="row">Last Update: <span
                class="text-muted">{{selectedCar.lastUpdatedOn | date :'medium'}}</span></span>
              <span class="row"> Stop Duration: <span class="text-muted"><span
                *ngIf="getStopDuration(this.selectedCar.lastUpdatedOn)['days']">{{getStopDuration(this.selectedCar.lastUpdatedOn)['days']}}
                days </span>
                <span
                  *ngIf="getStopDuration(this.selectedCar.lastUpdatedOn)['hours']">{{getStopDuration(this.selectedCar.lastUpdatedOn)['hours']}}
                  h </span><span
                  *ngIf="getStopDuration(this.selectedCar.lastUpdatedOn)['minutes']">{{getStopDuration(this.selectedCar.lastUpdatedOn)['minutes']}}
                  mins</span>
                <span
                  *ngIf="!getStopDuration(this.selectedCar.lastUpdatedOn)['hours'] && !getStopDuration(this.selectedCar.lastUpdatedOn)['minutes']">-</span></span></span>
              <span class="row">Driver: <span class="text-muted">{{selectedCar.user.userFullName}}
                ({{selectedCar.user.userPhoneNumber}})</span></span>
            </div>
          </td>
          <td style="min-width:216px;width: 216px" class="pl-4">
            <span
              class="row"><b>Trip Distance:&#160;</b> {{selectedTrip?.distanceCovered || lastTripData?.tripDistance || '-'}}Km
            </span>
            <span
              class="row"><b>Trip Safe km:&#160;</b> {{selectedTrip?.safeKm || lastTripData?.safeKm || '-'}}
              Km</span>
            <span
              class="row"><b>Total Safety Score:&#160;</b> {{selectedTrip?.safetyScore || lastTripData?.safetyScore || '-'}}%
              </span> 
          </td>
          <td style="min-width:216px;width: 216px">
            <div *ngFor="let alert of selectedVehicleAlerts" class="pb-2">
              <p class="p-0 m-0"><b>{{alert.troubleCode |uppercase}}</b></p>
              <p class="p-0 m-0">{{alert.errorDesc}}</p>
            </div>
            <a href="javascript:void(0)" *ngIf="selectedVehicleAlerts && selectedVehicleAlerts.length"
               [routerLink]="['/customers',selectedCar.user.userId,'vehicles',
               selectedCar.userVehicleId,'trouble-codes']"
               [queryParams]="{name:(selectedCar.vehicleBrand+'-'+selectedCar.vehicleModel+'-'+selectedCar.regNumber)}">View
              All Trouble Codes</a>
          </td>
        </tr>

        </tbody>
      </table>
    </div>


    <!--    <div class="card mb-0 z-0">-->
    <!--      <div class="card-header pr-0">-->
    <!--        <div class="d-flex justify-content-around">-->
    <!--          <div class="col-4">-->
    <!--            <div class="row">-->
    <!--              <span class="pl-2">{{selectedCar.regNumber |uppercase}}</span>-->
    <!--              <div class=" d-flex align-items-center">-->
    <!--                <div class="pl-1 green-dot" *ngIf="isAnyUpdateOfCarInFiveMin(selectedCar)"></div>-->
    <!--                <div class="pl-1 red-dot" matTooltip="No update from Vehicle in last 5min"-->
    <!--                     *ngIf="!isAnyUpdateOfCarInFiveMin(selectedCar)"></div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="col-3 "> Driver Safety</div>-->
    <!--          <div class="col-4  " [ngClass]="isVehicleAlertsCardCollapsed?'text-left':'text-right text-nowrap'"><span>Active Trouble Codes</span>-->
    <!--          </div>-->
    <!--          <div class="col-1 pr-1" style="max-width: 50px;"><span class="pointer"-->
    <!--                                                                 (click)="isVehicleAlertsCardCollapsed = !isVehicleAlertsCardCollapsed"-->
    <!--                                                                 [attr.aria-expanded]="!isVehicleAlertsCardCollapsed"-->
    <!--                                                                 aria-controls="collapseExample">-->
    <!--              <i class="fa fa-angle-down text-dark fa-2x" matTooltip="Expand" *ngIf="!isVehicleAlertsCardCollapsed"></i>-->
    <!--              <i class="fa fa-angle-up text-dark fa-2x" matTooltip="Minimize"-->
    <!--                 *ngIf="isVehicleAlertsCardCollapsed"></i></span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="card-body pt-0 pb-0 " [ngbCollapse]="isVehicleAlertsCardCollapsed">-->
    <!--        <div class="d-flex justify-content-around pt-1 pb-1">-->
    <!--          <div class="col-4 pl-0">-->
    <!--            <div>Address:-->
    <!--              <p>{{selectedVehicleLiveLocation}}</p></div>-->
    <!--            <div>Last Updated:-->
    <!--              <p>{{selectedCar.lastUpdatedOn | date :'medium'}}</p></div>-->
    <!--            <div>Stop Duration:-->
    <!--              <p><b><span-->
    <!--                *ngIf="getStopDuration(this.selectedCar.lastUpdatedOn)['days']">{{getStopDuration(this.selectedCar.lastUpdatedOn)['days']}}-->
    <!--                days </span>-->
    <!--                <span-->
    <!--                  *ngIf="getStopDuration(this.selectedCar.lastUpdatedOn)['hours']">{{getStopDuration(this.selectedCar.lastUpdatedOn)['hours']}}-->
    <!--                  h </span><span-->
    <!--                  *ngIf="getStopDuration(this.selectedCar.lastUpdatedOn)['minutes']">{{getStopDuration(this.selectedCar.lastUpdatedOn)['minutes']}}-->
    <!--                  mins</span>-->
    <!--                <span-->
    <!--                  *ngIf="!getStopDuration(this.selectedCar.lastUpdatedOn)['hours'] && !getStopDuration(this.selectedCar.lastUpdatedOn)['minutes']">-</span></b>-->
    <!--              </p></div>-->
    <!--            <div>Driver:-->
    <!--              <p class="p-0 m-0">{{selectedCar.user.userFullName}}</p>-->
    <!--              <p>{{selectedCar.user.userPhoneNumber}}</p></div>-->
    <!--          </div>-->
    <!--          <mat-divider [vertical]="true" class="p-0 m-0"></mat-divider>-->
    <!--          <div class="col-3">-->

    <!--            <b>Total Trips Taken</b>-->
    <!--            <p>{{this.selectedVehicleUserDrivingAnalytics ? this.selectedVehicleUserDrivingAnalytics.totalTrips : ''}}-->
    <!--              Trips</p>-->
    <!--            <b>Total Distance Travelled</b>-->
    <!--            <p>{{this.selectedVehicleUserDrivingAnalytics ? (this.selectedVehicleUserDrivingAnalytics.totalDistanceTravelledInKm | number: '1.0-0') : ''}}-->
    <!--              Km</p>-->
    <!--            <b>Total Safe Km Driven</b>-->
    <!--            <p>{{this.selectedVehicleUserDrivingAnalytics ? (this.selectedVehicleUserDrivingAnalytics.totalSafeTripsDistance | number: '1.0-0') : ''}}-->
    <!--              Km</p>-->
    <!--          </div>-->
    <!--          <mat-divider [vertical]="true" class="p-0 m-0"></mat-divider>-->
    <!--          <div class="col-4 vehicle-alerts-list">-->
    <!--            <div *ngFor="let alert of selectedVehicleAlerts" class="pb-2">-->
    <!--              <p class="p-0 m-0"><b>{{alert.troubleCode |uppercase}}</b></p>-->
    <!--              <p class="p-0 m-0">{{alert.errorDesc}}</p>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->

    <!--      </div>-->
    <!--    </div>-->


  </div>
  <div id="over_map_4" class="bg-light pointer">
    <mat-icon class="screen" *ngIf="!isFullScreenEnabled" (click)="openFullscreen()">fullscreen</mat-icon>
    <mat-icon class="screen" *ngIf="isFullScreenEnabled" (click)="closeFullscreen()">fullscreen_exit</mat-icon>
  </div>
  <div id="over_map_5" class="bg-light">
    <small class="p-2"><span class="text-danger">*</span>Select a car to start tracking live location</small>
  </div>
  <!--  Selected car alerts box ends here-->
</div>

